import React, { useContext, useState } from 'react';

import ModalsContext from '../context/modals.jsx';
import { Button, Box, TextField, Grid, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const PopupForm = () => {
	const modals_context = useContext(ModalsContext);

	const [uid, set_uid] = useState('');
	const [type, set_type] = useState('regular');

	const handle_submit = (event) => {
		event.preventDefault();
		const popup_data = { type, uid };
		if (type === 'regular') {
			popup_data.content = [];
		}
		modals_context.data.clb(popup_data);
		modals_context.hide();
	};

	return (
		<form onSubmit={handle_submit}>
			<Grid container spacing={3}>
				<Grid item xs={12} sm={6}>
					<TextField required id="popup_name" name="popup_name" label="Name" fullWidth value={uid} onChange={(e) => set_uid(e.target.value)} />
				</Grid>
				<Grid item xs={12} sm={6}>
					<FormControl fullWidth>
						<InputLabel id="type">Type</InputLabel>
						<Select labelId="type" id="type" value={type} label="Type" onChange={(e) => set_type(e.target.value)}>
							<MenuItem value="regular">regular</MenuItem>
							<MenuItem value="viewer">viewer</MenuItem>
						</Select>
					</FormControl>
				</Grid>
			</Grid>
			<Box textAlign="center">
				<Button variant="contained" type="submit" sx={{ mt: 2 }}>
					Add
				</Button>
			</Box>
		</form>
	);
};

export default PopupForm;
